import { render, staticRenderFns } from "./BosFooter.vue?vue&type=template&id=1f2f46d0&scoped=true"
import script from "./BosFooter.vue?vue&type=script&lang=js"
export * from "./BosFooter.vue?vue&type=script&lang=js"
import style0 from "./BosFooter.vue?vue&type=style&index=0&id=1f2f46d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f46d0",
  null
  
)

export default component.exports